'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | Thu 5 Dec
 * `en-us` | Thu, Dec 5
 * `es` | jue, 5 dic
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/date_format_new/short_date_with_weekday_without_year/name
 */
var form = 'short_date_with_weekday_without_year';
lingojsCore.registerDynamicTags(lingojsCore.t('date_format_new', form, 'name'));

module.exports = form;
//# sourceMappingURL=index.js.map
